import { render, staticRenderFns } from "./NewYagiofferEdit.vue?vue&type=template&id=6594d5a8&scoped=true"
import script from "./NewYagiofferEdit.vue?vue&type=script&lang=js"
export * from "./NewYagiofferEdit.vue?vue&type=script&lang=js"
import style0 from "./NewYagiofferEdit.vue?vue&type=style&index=0&id=6594d5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6594d5a8",
  null
  
)

export default component.exports